import React, { useState, useContext, useEffect, useReducer } from 'react';
import { useHistory } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { Button, Modal } from 'react-bootstrap';
import { AuthContext } from '../AuthContext';
import { useViewPort } from './Hooks/useViewPort';
import { getAPI } from './GdacsAPI';
import { getToken, saveToken } from './Hooks/Token';

const ActiveAccount = (props) => {
    const authContext = useContext(AuthContext);
    const [responseMessage, setResponseMessage] = React.useState("");
    const query = new URLSearchParams(props.location.search);
    const username = query.get('username');
    const { width } = useViewPort();
    const breakpoint = 520;
    const initDataObject = { username: "", password: "" }
    const [show, setShow] = React.useState(false);
    const [isToValidate, setIsToValidate] = React.useState();

    const checkValidation = Yup.object().shape({
        password: Yup.string().required("No password provided.")//.min(8, "Password is too short - should be 8 chars minimum."),
    })

    async function GetUserToken(values, username) {
        let json = {
            username: username,
            password: values.password
        }
        const settings = {
            method: 'POST',
            type: 'no-cors',
            body: JSON.stringify(json),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        };

        const response = await fetch(getAPI() + `api/register/Users/authenticate/`, settings)
        if (!response.ok) {
            const resp = await response.json();
            setResponseMessage(resp.message);
            return;
        }
        else {

            const dataUser = await response.json();

            authContext.login(dataUser);

            if (dataUser.enabled === false && dataUser.status === "Deleted") {
                setResponseMessage(<>Your account has been deleted... if you want recover it, please contact <a href="/About/contactus.aspx" target="_blank" >us</a ></>);
                return;
            }

            if (dataUser.enabled === true && dataUser.status === "confirmed") {
                setResponseMessage(<>Your account has already been activated... Now you can try to login on dacs Register </>);
                return;
            }

            if (dataUser.enabled === false && dataUser.status.startsWith("2")) {
                SaveRecord(dataUser);
            }
        }

    }

    async function SaveRecord(userData) {

        let address = [];
        for (let i = 0; i < userData.addresses.length; i++) {
            address.push({
                idUserAddress: userData.addresses[i].idUserAddress, idUser: userData.idUser, idServiceType: userData.addresses[i].idServiceType, addressOption: userData.addresses[i].addressOption,
                deviceKey: userData.addresses[i].deviceKey === "", addressValue: userData.addresses[i].addressValue, checkcode: userData.addresses[i].checkcode,
                checkvalidate: userData.addresses[i].checkvalidate, checkdate: userData.addresses[i].checkdate, requiretest : userData.addresses[i].requiretest
            });
            if (userData.addresses[i].idServiceType === 1 || userData.addresses[i].idServiceType === 3) {
                if (userData.addresses[i].checkvalidate === false)
                    setIsToValidate(true);
            }
        }


        let services = [];
        for (let i = 0; i < userData.services.length; i++) {
            services.push({
                idService: userData.services[i].idService, idUser: userData.idUser, idServiceType: userData.services[i].idServiceType,
                eventType: userData.services[i].eventType, alertLevel: userData.services[i].alertLevel, region: userData.services[i].region, language: userData.services[i].language,
                stopNight: userData.services[i].stopNight, enabled: userData.services[i].enabled
            });
        }

        let json = {
            idUser: userData?.idUser,
            lastName: userData?.lastName,
            firstName: userData?.firstName,
            country: userData?.country,
            email: userData?.email,
            enabled: true,
            emailOption: userData?.emailOption,
            username: userData?.username,
            password: userData?.password,
            notes: userData?.notes,
            organisation: userData?.organisation,
            orgtype: userData?.orgtype,
            status: "confirmed",
            confirmstatus: "confirmed",
            datemodified: userData.datemodified,
            utcOffset: userData?.utcOffset,
            addresses: address,
            services: services,
            token: userData?.token ? userData.token : ""
        };


        const settings = (!userData?.idUser) ? {
            method: 'POST',
            body: JSON.stringify(json),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        } :
            {
                method: 'POST',
                body: JSON.stringify(json),
                headers: {
                    'Authorization': 'Bearer ' + getToken(),
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                }
            }

        const api = getAPI() + `api/register/Users/update`;
        const response = await fetch(api, settings);

        if (!response.ok) {
            const resp = await response.json();
            setResponseMessage(resp.message);
            return;
        }
        else {
            const resp = await response.json();
            authContext.update(resp);
            setShow(true);
        }
    }

    const handleFormikSubmit = (values, { setSubmitting }) => {
        setSubmitting(false);
        GetUserToken(values, username);
    }

    const handleClose = () => {
        setShow(false);
    }

    return (

        <Formik
            initialValues={initDataObject}
            validationSchema={checkValidation}
            onSubmit={handleFormikSubmit}
        >
            {({
                values,
                touched,
                errors,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit
            }) => (
                <div>
                    <form onSubmit={handleSubmit}>
                        <br />
                        <br />
                        <div className="login-wrapper">
                            <div className={(breakpoint > width ? "col-12 p_summary" : "col-8 p_summary")}>
                                For users registered after 2008, the username is an email address. Users registered before might have usernames that are different.
                        </div>

                            <div className={(breakpoint > width ? "col-12" : "col-4")}>
                                <br />
                                <label htmlFor="username">Username</label>
                                <input className="form-control form-control-sm"
                                    name="username"
                                    type="mail"
                                    placeholder="Enter your Username"
                                    value={username}
                                    onChange={handleChange}
                                    disabled={true}
                                />
                                <br />
                                {errors.email && touched.username && (
                                    <div className="input-feedback">{errors.username}</div>
                                )}
                                <label htmlFor="password">Password</label>
                                <input className="form-control form-control-sm"
                                    name="password"
                                    type="password"
                                    placeholder="Enter your password"
                                    value={values.password}
                                    onChange={handleChange}
                                    on onBlur={handleBlur}
                                />
                                <br />
                                {errors.password && touched.password && (
                                    <div className="input-feedback">{errors.password}</div>
                                )}
                                {responseMessage &&
                                    <div className="input-feedback">{responseMessage}</div>
                                }
                                <br />
                                <button type="button " className="btn btn-primary btn-primary-login float-right btn-sm" style={{ minWidth: "115px" }} onClick={handleSubmit}>
                                    Activate Account
                        </button>
                                <Modal show={show} onHide={handleClose}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Validate Your Number</Modal.Title>
                                    </Modal.Header>
                                    <><Modal.Body>To receive the GDACS alerts, first you need to validate your channels.
                                                  Do you want to do it now?</Modal.Body>
                                        <Modal.Footer>
                                            <NavLink
                                                to={{
                                                /*                                                    pathname: '/ValidateNumber',*/
                                                    pathname: '/ValidateContainer',
                                                    origin: "ActiveAccount",
                                                }}
                                                className="btn btn-primary " >
                                                Yes
                                    </NavLink>
                                            <NavLink
                                                to={{
                                                    pathname: '/Home',
                                                    origin: "ActiveAccount",
                                                }}
                                                className="btn btn-primary " >
                                                No
                                    </NavLink>
                                        </Modal.Footer></>
                                </Modal>
                                <br />
                            </div>
                            <div className={(breakpoint > width ? "col-12" : "col-8")}>
                                <br />
                                <br />
                                <div className="p_summary" style={{ fontSize: "14px" }}>
                                    <b>Conditions for use:</b> <br />
                                    The data you provide in this form is kept for the purpose of alerting you <br /> and for internal usage statistics. The information will not be disclosed to third parties, unless it is necessary for the fulfillment of the purpose identified above.<br />
                                    Your data is kept for 1 year after you unregister from the system.<br /> For further information on the European Commission Personal Data Protection <a href="https://ec.europa.eu/dpo-register/detail/DPR-EC-00240" target="_blank">DPR-EC-00240.1</a>.<br />
                                    For further inquiries, contact <a href="/About/contactus.aspx" target="_blank">us</a>.
                                </div>

                            </div>
                        </div>
                        <br />
                        <br />
                    </form>
                </div>

            )}
        </Formik>
    );
}

export { ActiveAccount };